import { gql } from '@apollo/client'

const PATCH_MEMBER_STATUS = gql`
  mutation memberStatus($documentNumber: ID!, $memberStatus: MemberStatusInput!) {
    memberStatus(documentNumber: $documentNumber, memberStatus: $memberStatus) {
      statusCode
      error
      message
    }
  }
`

export default PATCH_MEMBER_STATUS
